import { DATE_FORMATS } from "constants/dateConstants";
import moment, { Moment } from "moment";

export function parseDate(dateString?: string | null): Moment | null {
  return dateString ? moment(dateString) : null;
}

export function getCurrentDate(): Moment {
  return moment();
}

export function formatDate(
  date: Moment,
  format: string = DATE_FORMATS.DATE_ONLY,
): string {
  return date.format(format);
}

export function getStartOfDay(date: Moment): Moment {
  return date.startOf("day");
}

export function getEndOfDay(date: Moment): Moment {
  return date.endOf("day");
}

export function getEarliestTimeOfDayFromEvents(events: { start: string | Date }[]): Date {
  if (events.length === 0) return new Date(1970, 1, 1, 0, 0);

  const minutesArray = events.map(event => {
    const date = new Date(event.start);
    return date.getHours() * 60 + date.getMinutes();
  });

  const earliestMinutes = Math.min(...minutesArray);
  const hours = Math.floor(earliestMinutes / 60);
  const minutes = earliestMinutes % 60;

  return new Date(1970, 1, 1, hours, minutes);
}